module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/92/assets/images/621f18c4ac0a250be364bc964699d809.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Bronze/Bronze3.svg
// module id = 4Ksa
// module chunks = 1